/**
 * @fileoverview Device detection utilities
 * @module shared/utils/device
 */

/**
 * Detects if the current device is a mobile device.
 *
 * Used to adjust OAuth flow (redirect vs popup) and UI behavior.
 * On mobile, popup-based OAuth is blocked by browsers, so redirect flow is preferred.
 *
 * @returns True if the device is mobile (iOS or Android)
 *
 * @example
 * ```typescript
 * const isMobile = isMobileDevice();
 * if (isMobile) {
 *   // Use redirect-based OAuth flow
 * } else {
 *   // Use popup-based OAuth flow
 * }
 * ```
 */
export function isMobileDevice(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}
